import NotificationItem from "../components/Notifications/NotificationItem";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import "../utils/echo";
import { useNotification } from "../components/Notifications/NotificationContext";

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const token = localStorage.getItem("auth_token");
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.id;
  const { unreadCount, setUnreadCount } = useNotification();

  const fetchNotifications = async () => {
    const res = await fetch("https://loopsneller.com/api/notifications", {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (res.ok) {
      const data = await res.json();
      setNotifications(data);
    }
  };

  useEffect(() => {
    fetchNotifications();

    if (userId) {
      window.Echo.private(`notifications.${userId}`).listen(
        ".new-notification",
        (event) => {
          setNotifications((prev) => [event, ...prev]);
        }
      );
    }

    return () => {
      if (userId) {
        window.Echo.leaveChannel(`private-notifications.${userId}`);
      }
    };
  }, [userId]);

  const markAsRead = async (id) => {
    await fetch(`https://loopsneller.com/api/notifications/${id}/mark-read`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}` },
    });

    setNotifications((prev) =>
      prev.map((n) => (n.id === id ? { ...n, is_read: true } : n))
    );

    // Decrement unread count only if this notification was unread
    const markedNotification = notifications.find((n) => n.id === id);
    if (markedNotification && !markedNotification.is_read) {
      setUnreadCount((prev) => Math.max(prev - 1, 0));
    }
  };

  const deleteNotification = async (id) => {
    await fetch(`https://loopsneller.com/api/notifications/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });

    setNotifications((prev) => prev.filter((n) => n.id !== id));
  };

  const undoDelete = async (id) => {
    const res = await fetch(
      `https://loopsneller.com/api/notifications/${id}/restore`,
      {
        method: "PUT",
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (res.ok) {
      const { notification } = await res.json();
      return notification; // return so NotificationItem can use it
    }

    return null;
  };

  return (
    <div className="container mt-4">
      <h3>Your Notifications</h3>
      <ul className="list-group">
        {notifications.map((n, index) => (
          <NotificationItem
            key={n.id}
            notification={n}
            index={index} // ✅ pass index
            onMarkAsRead={markAsRead}
            onDelete={deleteNotification}
            onUndo={undoDelete}
            onRestore={(restored, restoreIndex) => {
              setNotifications((prev) => {
                const updated = [...prev];
                updated.splice(restoreIndex, 0, restored); // 👈 insert at same index
                return updated;
              });
            }}
          />
        ))}
      </ul>
    </div>
  );
};

export default NotificationsPage;
